<template>
  <div
    class="main--text">
    <v-row
      align="center"
      justify="center"
    >
      <v-col md=8 sm=10>
        <v-card>
          <v-container
            fluid>
          <v-row
            no-gutters>
            <v-col>
              <h2>保護者用 新規登録フォーム</h2>
            </v-col>
          </v-row>
          <v-card-text
            class="font-weight-bold red--text"
            v-show="errorMessage">{{errorMessage}}
          </v-card-text>
            <v-form>
              <v-text-field
                v-model="email"
                name="username"
                label="メールアドレス"
                type="text"
                v-validate="'required|email'"
                data-vv-name="email"
                data-vv-as="メールアドレス"
                required
                :error-messages="errors.collect('email')"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="パスワード"
                type="password"
                v-validate="'required|min:4|max:8|alpha_num'"
                data-vv-name="password"
                data-vv-as="パスワード"
                required
                ref="password"
                :error-messages="errors.collect('password')"
              ></v-text-field>
              <v-text-field
                v-model="confirmPassword"
                label="パスワード(確認用)"
                type="password"
                v-validate="'required|confirmed:password'"
                data-vv-name="confirmPassword"
                data-vv-as="パスワード(確認用)"
                required
                :error-messages="errors.collect('confirmPassword')"
              ></v-text-field>
            </v-form>
            <p>下記「ご利用規約」をお読みのうえ、「同意する」にチェックをしてください。</p>
            <v-row
              align=end
              justify=center
              no-gutters>
              <v-col
                cols=auto>
                <h3><a @click="termsDialog=true"><u>Prosense ご利用規約</u></a></h3>
              </v-col>
            </v-row>
            <v-row
              align=start
              justify=center
              no-gutters>
              <v-col
                cols=auto>
                <v-checkbox
                  label="ご利用規約に同意する"
                  v-model="termsChecked"></v-checkbox>
              </v-col>
            </v-row>
            <v-row
              justify="end"
              no-gutters
              >
              <v-col
                cols="auto">
                <v-btn
                  rounded
                  outlined
                  color="primary"
                  @click="submit()"
                  >登録
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      :value="termsDialog"
      persistent
      width="1000"
      >
      <v-card>
        <v-container
          fluid
        >
          <v-terms-of-service/>
          <v-row
            justify=center>
            <v-col
              cols="auto">
              <p
              class="clickable--text"
              @click="termsDialog=false">利用規約を閉じる</p>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="checkTermsDialog"
      persistent
      width="350">
      <v-card
        class="main--text">
        <v-container
          fluid>
          <v-row>
            <v-col>
              <span style="font-weight: bold">ご利用規約をご確認の上、<br>「同意する」にチェックをしてください。</span>
            </v-col>
          </v-row>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <v-btn
                rounded
                outlined
                color="primary"
                @click="checkTermsDialog=false">
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VTermsOfService from '@/components/organisms/parent/VTermsOfService.vue'

export default {
  components: {
    VTermsOfService
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    errorMessage: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      termsDialog: false,
      termsChecked: false,
      checkTermsDialog: false
    }
  },
  methods: {
    updateValue (diff) {
      this.$emit('input', {...this.value, ...diff})
    },
    submit() {
      if (!this.termsChecked) {
        this.checkTermsDialog = true
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$emit('submit-button-click')
          }
        })
      }
    }
  },
  computed: {
    email: {
      get() {
        return this.value.email
      },
      set (email) {
        this.updateValue({email})
      }
    },
    password: {
      get() {
        return this.value.password
      },
      set(password) {
        this.updateValue({password})
      }
    },
    confirmPassword: {
      get () {
        return this.value.confirmPassword
      },
      set(confirmPassword) {
        this.updateValue({confirmPassword})
      }
    }
  }
}
</script>

<style scoped>
.clickable--text {
  display: inline-block;
  text-decoration-line: underline;
  padding: 2px;
  border-radius: 3px;
  cursor: pointer;
  color: rgba(0, 81, 255)
}

.clickable--text:hover {
  color:azure;
  background-color: rgb(226, 223, 223);
  transition: 0.15s;
}

</style>
